import { Button, makeStyles } from '@rneui/themed'
import { t } from 'app/i18l'
import { useRoutingContext } from 'app/routing_context'
import { useFreshchatContext } from 'freshchat/service/context'
import React from 'react'
import { Platform } from 'react-native'
interface Props {
  isCompact?: boolean
  disabled?: boolean
}

export function SupportButton({ isCompact, disabled }: Props) {
  const styles = useStyles()
  const freshchat = useFreshchatContext()
  const { handleNavigation } = useRoutingContext()

  const onPress = () => {
    if (Platform.OS === 'web') {
      handleNavigation({ routeName: 'freshchat' })
    } else {
      freshchat.showConversationsAndFAQs()
    }
  }

  return isCompact ? (
    <Button
      disabled={disabled}
      buttonStyle={styles.compactHelpButton}
      icon={{
        name: 'help',
        color: styles.helpButtonIcon.color,
        type: 'ionicon',
      }}
      onPress={onPress}
    />
  ) : (
    <Button
      title={t('support')}
      disabled={disabled}
      buttonStyle={styles.helpButton}
      titleStyle={styles.helpButtonText}
      icon={{
        name: 'help',
        color: styles.helpButtonIcon.color,
        size: styles.helpButtonIcon.height,
        type: 'ionicon',
      }}
      iconPosition="top"
      onPress={onPress}
      titleProps={{ allowFontScaling: false }}
    />
  )
}

const useStyles = makeStyles(theme => ({
  helpButton: {
    width: 80,
    height: 70,
    borderRadius: 10,
  },
  compactHelpButton: {
    width: 50,
    height: 50,
    borderRadius: 25,
  },
  helpButtonIcon: {
    color: theme.colors?.white,
    height: 32,
  },
  helpButtonText: {
    color: theme.colors?.white,
    fontSize: 16,
  },
}))
